module.exports = {
    format: function(minutes) {
        let displayHours = Math.trunc(minutes / 60);
        let displayMinutes = parseFloat((minutes % 60).toFixed(0));

        if (displayMinutes === 0) {
            return displayHours + "h";
        } else {
            return displayHours + "h " + displayMinutes + "min";
        }
    }
};



/** WEBPACK FOOTER **
 ** ./src/app/utils/duration.js
 **/